import ReportsGateway from './ReportsGateway'

export default class ReportsService {
  constructor (reportsGateway) {
    this.ReportsGateway = reportsGateway || new ReportsGateway()

    this.getReport = this.getReport.bind(this)
    this.getReportsPowerBiToken = this.getReportsPowerBiToken.bind(this)
    this.getReportParameters = this.getReportParameters.bind(this)
    this.getReports = this.getReports.bind(this)
    this.saveReport = this.saveReport.bind(this)
    this.generateReport = this.generateReport.bind(this)
    this.deleteReport = this.deleteReport.bind(this)
    this.updateReport = this.updateReport.bind(this)
    this.generateReportPDF = this.generateReportPDF.bind(this)
    this.getBulkReports = this.getBulkReports.bind(this)
    this.getIndividualReports = this.getIndividualReports.bind(this)
    this.bulkReportsStop = this.bulkReportsStop.bind(this)
    this.bulkReportsClear = this.bulkReportsClear.bind(this)
    this.getGeneratedReports = this.getGeneratedReports.bind(this)
    this.generateReportJSON = this.generateReportJSON.bind(this)
    this.bulkReportsDownload = this.bulkReportsDownload.bind(this)
    this.bulkReportsDownloadAll = this.bulkReportsDownloadAll.bind(this)
    this.bulkReportsDownloadPDF = this.bulkReportsDownloadPDF.bind(this)
    this.bulkReportsDownloadAllPDF = this.bulkReportsDownloadAllPDF.bind(this)
    this.generateFinishReport = this.generateFinishReport.bind(this)
    this.getStatusReport = this.getStatusReport.bind(this)
    this.getReportManagerList = this.getReportManagerList.bind(this)

    this.sendEmailsCheck = this.sendEmailsCheck.bind(this)
    this.previewEmails = this.previewEmails.bind(this)
    this.sendEmails = this.sendEmails.bind(this)
    this.continueSendEmails = this.continueSendEmails.bind(this)
  }

  continueSendEmails (params) {
    return this.ReportsGateway
      .continueSendEmails(params)
      .then(response => response)
  }

  sendEmails (params) {
    return this.ReportsGateway
      .sendEmails(params)
      .then(response => response)
  }

  previewEmails (params) {
    return this.ReportsGateway
      .previewEmails(params)
      .then(response => response)
  }

  sendEmailsCheck (params) {
    return this.ReportsGateway
      .sendEmailsCheck(params)
      .then(response => response)
  }

  getReportManagerList (params) {
    return this.ReportsGateway
      .getReportManagerList(params)
      .then(response => response)
  }

  getStatusReport (params) {
    return this.ReportsGateway
      .getStatusReport(params)
      .then(response => response)
  }

  generateFinishReport (params) {
    return this.ReportsGateway
      .generateFinishReport(params)
      .then(response => response)
  }

  getReports () {
    return this.ReportsGateway
      .getReports()
      .then(response => response.map(item => ({
        ...item,
        value: item.name
      })))
  }

  getReportsPowerBiToken (params) {
    return this.ReportsGateway
      .getReportsPowerBiToken(params)
  }

  getIndividualReports () {
    return this.ReportsGateway
      .getIndividualReports()
      .then(response => response.map(item => ({
        ...item,
        value: item.name
      })))
  }

  getBulkReports () {
    return this.ReportsGateway
      .getBulkReports()
      .then(response => response.map(item => ({
        ...item,
        value: item.name
      })))
  }

  getGeneratedReports (params) {
    return this.ReportsGateway
      .getGeneratedReports(params)
      .then(response => response)
  }

  getReport (params) {
    return this.ReportsGateway
      .getReport(params)
      .then(response => response)
  }

  getReportParameters (params) {
    return this.ReportsGateway
      .getReportParameters(params)
      .then(response => response)
  }

  saveReport (query) {
    return this.ReportsGateway
    .saveReport(query)
    .then(response => response)
  }

  bulkReportsClear (query) {
    return this.ReportsGateway
    .bulkReportsClear(query)
    .then(response => response)
  }

  bulkReportsStop (query) {
    return this.ReportsGateway
    .bulkReportsStop(query)
    .then(response => response)
  }

  updateReport (query) {
    return this.ReportsGateway
    .updateReport(query)
    .then(response => response)
  }

  generateReport (query) {
    return this.ReportsGateway
    .generateReport(query)
    .then(response => response)
  }

  bulkReportsDownload (query) {
    return this.ReportsGateway
    .bulkReportsDownload(query)
    .then(response => response)
  }

  bulkReportsDownloadAll (query) {
    return this.ReportsGateway
    .bulkReportsDownloadAll(query)
    .then(response => response)
  }

  bulkReportsDownloadPDF (query) {
    return this.ReportsGateway
    .bulkReportsDownloadPDF(query)
    .then(response => response)
  }

  bulkReportsDownloadAllPDF (query) {
    return this.ReportsGateway
    .bulkReportsDownloadAllPDF(query)
    .then(response => response)
  }

  generateReportJSON (query) {
    return this.ReportsGateway
    .generateReportJSON(query)
    .then(response => response)
  }

  generateReportPDF (query) {
    return this.ReportsGateway
    .generateReportPDF(query)
    .then(response => response)
  }

  deleteReport (query) {
    return this.ReportsGateway
    .deleteReport(query)
    .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/reports/ReportsService.js